import {combineReducers} from 'redux';

import presets from './discount-presets/reducer';

export default combineReducers({
    presets,
});
